import { useState } from "react"
import styled from "styled-components"

import { Text } from "@minuthq/meatball-ui-react"

import { UserOrdersTable } from "src/components/Account/BillingPortal/UserOrders/UserOrdersTable"
import { NoUserOrders } from "src/components/EmptyState/NoUserOrders"
import { Pager } from "src/components/Pager/Pager"
import { useFetchUserOrders } from "src/data/billing/queries/billingQueries"
import { useGetUser } from "src/data/user/hooks/useGetUser"
import { useTranslate } from "src/i18n/useTranslate"
import { MBanner } from "src/ui/MBanner/MBanner"
import { spacing } from "src/ui/spacing"

const PAGE_SIZE = 20

export function UserOrders() {
  const { user_id } = useGetUser()
  const [offset, setOffset] = useState(0)

  const fetchUserOrders = useFetchUserOrders({
    userId: user_id,
    filter: {
      offset,
      limit: PAGE_SIZE,
    },
    options: {
      keepPreviousData: true,
    },
  })

  const { t, langKeys } = useTranslate()

  const orders = fetchUserOrders.data?.orders || []

  if (fetchUserOrders.isError) {
    return (
      <MBanner type="error">{t(langKeys.failed_something_went_wrong)}</MBanner>
    )
  }

  return (
    <Grid>
      <Text variant="heading2">{t(langKeys.ecommerce_order_plural)}</Text>

      {!fetchUserOrders.isLoading && orders.length === 0 ? (
        <NoUserOrders />
      ) : (
        <>
          <UserOrdersTable
            orders={orders}
            loading={fetchUserOrders.isLoading}
          />

          <Text
            variant="bodyXS"
            color="secondary"
            textAlign="center"
            marginBottom={spacing.L}
          >
            {t(langKeys.orders_previous_orders_not_visible)}
          </Text>
        </>
      )}

      <Pager
        offset={offset}
        limit={PAGE_SIZE}
        totalCount={fetchUserOrders.data?.paging?.total_count}
        setOffset={setOffset}
      />
    </Grid>
  )
}

const Grid = styled.div`
  display: grid;
  gap: ${spacing.M};
`
